import { render, staticRenderFns } from "./ModalDownloadFileComponent.vue?vue&type=template&id=7b240091"
import script from "./ModalDownloadFileComponent.vue?vue&type=script&lang=js"
export * from "./ModalDownloadFileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports